import v from "@babel/runtime/helpers/esm/classCallCheck";
import h from "@babel/runtime/helpers/esm/createClass";
import i from "@babel/runtime/helpers/esm/assertThisInitialized";
import C from "@babel/runtime/helpers/esm/inherits";
import x from "@babel/runtime/helpers/esm/createSuper";
import _ from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as S } from "@semcore/utils/lib/core/index";
import o from "react";
import { CORE_INSTANCE as b, sstyled as y, Component as I } from "@semcore/core";
import P from "@semcore/divider";
import { localizedMessages as m } from "./translations/__intergalactic-dynamic-locales.mjs";
import k from "@semcore/utils/lib/enhances/i18nEnhance";
import T from "@semcore/utils/lib/uniqueID";
var w = (
  /*__reshadow_css_start__*/
  (S.insert(
    /*__inner_css_start__*/
    '.___SColorPickerPopper_15lm4_gg_{max-width:calc(var(--intergalactic-spacing-4x, 16px)*2 + 28px*6 + 4px*6);padding:var(--intergalactic-spacing-4x, 16px)}.___SItemContainer_15lm4_gg_{position:relative;display:flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50%;border:1px solid transparent;outline:0;cursor:pointer}@media (hover:hover){.___SItemContainer_15lm4_gg_:hover{border:1px solid var(--intergalactic-border-secondary, #e0e1e9)}}.___SItemContainer_15lm4_gg_::after{content:"";position:absolute;width:22px;height:22px;border-radius:50%;box-shadow:inset 0 0 1px var(--intergalactic-border-secondary, #e0e1e9);background:var(--value_15lm4)}@media (hover:hover){.___SItemContainer_15lm4_gg_:hover>.___SCloseIcon_15lm4_gg_{opacity:1}}.___SItemContainer_15lm4_gg_.__keyboardFocused_15lm4_gg_{box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5))}.___SItemContainer_15lm4_gg_.__selected_15lm4_gg_{border:1px solid var(--intergalactic-border-info-active, #006dca)}.___SItemContainer_15lm4_gg_.__displayLabel_15lm4_gg_::after{background:var(--value_15lm4);opacity:.15}.___SItemContainer_15lm4_gg_:not(.__value_15lm4_gg_)::after{border:.9px solid var(--intergalactic-border-secondary, #e0e1e9)}.___SColorsContainer_15lm4_gg_,.___SColors_15lm4_gg_{display:flex;flex-wrap:wrap;align-items:center;gap:var(--intergalactic-spacing-1x, 4px)}.___SPaletteManager_15lm4_gg_{justify-content:space-between;margin-top:var(--intergalactic-spacing-3x, 12px);margin-left:calc(var(--intergalactic-spacing-1x, 4px) - 1px)}.___SInputContainer_15lm4_gg_,.___SPaletteManager_15lm4_gg_,.___SPlusButton_15lm4_gg_{display:flex;align-items:center}.___SPlusButton_15lm4_gg_{justify-content:center;width:28px;height:28px;border-radius:50%;cursor:pointer}@media (hover:hover){.___SPlusButton_15lm4_gg_:hover{background-color:var(--intergalactic-bg-secondary-neutral-hover, #e0e1e9)}}.___SDefaultTrigger_15lm4_gg_{display:inline-flex;align-items:center;outline:0;cursor:pointer;border:0;background:0 0;padding:0}.___SDefaultTrigger_15lm4_gg_.__keyboardFocused_15lm4_gg_{box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5))}.___STriggerCircle_15lm4_gg_{position:relative;width:16px;height:16px;margin-right:calc(var(--intergalactic-spacing-1x, 4px) + 1px);border-radius:50%;background-color:var(--data-value_15lm4);border:1px solid transparent}.___STriggerCircle_15lm4_gg_:not([data-value]){border:1px solid var(--intergalactic-border-secondary, #e0e1e9)}.___STriggerCircleLine_15lm4_gg_{position:absolute;top:1px;left:1px}.___SCloseIcon_15lm4_gg_{position:absolute;top:0;right:0;display:flex;align-items:center;justify-content:center;width:12px;height:12px;border-radius:50%;background-color:var(--intergalactic-bg-primary-neutral, #ffffff);opacity:0;z-index:1}.___SLine_15lm4_gg_{position:absolute}.___SLabel_15lm4_gg_{z-index:1;color:var(--data-value_15lm4);font-size:calc(var(--intergalactic-fs-100, 12px) + 1px);font-weight:var(--intergalactic-bold, 700)}.___SItemColor_15lm4_gg_{width:20px;height:20px;border-radius:50%;border:1px solid var(--intergalactic-border-secondary, #e0e1e9);background:var(--data-value_15lm4)}.___SClearConfirm_15lm4_gg_.__hidden_15lm4_gg_,.___SConfirmColor_15lm4_gg_.__hidden_15lm4_gg_{display:none}',
    "15lm4_gg_"
  ), {
    __SColorPickerPopper: "___SColorPickerPopper_15lm4_gg_",
    __SItemContainer: "___SItemContainer_15lm4_gg_",
    __SCloseIcon: "___SCloseIcon_15lm4_gg_",
    _keyboardFocused: "__keyboardFocused_15lm4_gg_",
    _selected: "__selected_15lm4_gg_",
    __SColorsContainer: "___SColorsContainer_15lm4_gg_",
    __SColors: "___SColors_15lm4_gg_",
    __SPaletteManager: "___SPaletteManager_15lm4_gg_",
    __SInputContainer: "___SInputContainer_15lm4_gg_",
    __SDefaultTrigger: "___SDefaultTrigger_15lm4_gg_",
    __STriggerCircle: "___STriggerCircle_15lm4_gg_",
    "--data-value": "--data-value_15lm4",
    __STriggerCircleLine: "___STriggerCircleLine_15lm4_gg_",
    __SLine: "___SLine_15lm4_gg_",
    __SLabel: "___SLabel_15lm4_gg_",
    __SItemColor: "___SItemColor_15lm4_gg_",
    __SConfirmColor: "___SConfirmColor_15lm4_gg_",
    _hidden: "__hidden_15lm4_gg_",
    __SClearConfirm: "___SClearConfirm_15lm4_gg_",
    "--value": "--value_15lm4",
    _displayLabel: "__displayLabel_15lm4_gg_",
    _value: "__value_15lm4_gg_",
    __SPlusButton: "___SPlusButton_15lm4_gg_"
  })
), L = [k(m), T()], d = /* @__PURE__ */ function(p) {
  C(g, p);
  var u = x(g);
  function g() {
    var e;
    v(this, g);
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    return e = u.call.apply(u, [this].concat(n)), _(i(e), "refInput", /* @__PURE__ */ o.createRef()), _(i(e), "state", {
      focus: !1
    }), _(i(e), "bindHandlerItemRemove", function(r) {
      return function(l) {
        l.stopPropagation();
        var s = e.asProps.colors, c = s === void 0 ? [] : s;
        e.handlers.colors(c.filter(function(f) {
          return f !== r;
        }), l);
      };
    }), _(i(e), "bindHandlerItemAdd", function() {
      return function(r, l) {
        var s = e.asProps.colors, c = s === void 0 ? [] : s;
        c.includes(r) || e.handlers.colors(c.concat(r), l);
      };
    }), _(i(e), "bindHandlerButtonClick", function() {
      return function() {
        var r;
        (r = e.refInput.current) === null || r === void 0 || r.focus(), e.onFocus();
      };
    }), _(i(e), "onFocus", function() {
      return e.setState({
        focus: !0
      });
    }), _(i(e), "onBlur", function() {
      return e.setState({
        focus: !1
      });
    }), e;
  }
  return h(g, [{
    key: "uncontrolledProps",
    value: function() {
      return {
        colors: []
      };
    }
  }, {
    key: "getColorsProps",
    value: function() {
      var t = this.asProps.colors;
      return {
        colors: t,
        editable: !0,
        onPlusButtonClick: this.bindHandlerButtonClick(),
        getI18nText: this.asProps.getI18nText
      };
    }
  }, {
    key: "getItemProps",
    value: function(t) {
      var n = t.value, a = this.asProps.uid;
      return {
        uid: a,
        editable: !0,
        onRemove: this.bindHandlerItemRemove(n),
        getI18nText: this.asProps.getI18nText
      };
    }
  }, {
    key: "getInputColorProps",
    value: function() {
      return {
        ref: this.refInput,
        onAdd: this.bindHandlerItemAdd(),
        focus: this.state.focus,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        getI18nText: this.asProps.getI18nText
      };
    }
  }, {
    key: "render",
    value: function() {
      var t, n = this.asProps, a = n.styles, r = n.Children, l = this[b];
      return t = y(a), /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(P, t.cn("Divider", {
        mt: 3,
        mb: 3
      })), r.origin ? /* @__PURE__ */ o.createElement(r, t.cn("Children", {})) : /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(l.Colors, null), /* @__PURE__ */ o.createElement(l.InputColor, null)));
    }
  }]), g;
}(I);
_(d, "displayName", "PaletteManager");
_(d, "style", w);
_(d, "enhance", L);
_(d, "defaultProps", {
  defaultColors: [],
  i18n: m,
  locale: "en"
});
export {
  d as default
};
